import { render, staticRenderFns } from "./AreaSelecter.vue?vue&type=template&id=6815e097&scoped=true&"
import script from "./AreaSelecter.vue?vue&type=script&lang=js&"
export * from "./AreaSelecter.vue?vue&type=script&lang=js&"
import style0 from "./AreaSelecter.vue?vue&type=style&index=0&id=6815e097&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6815e097",
  null
  
)

export default component.exports